import config from '@project/config';

const membershipRenewalBaseUrl = `${config.apiUrl}/general_informations`;

export default {
  getMembershipRenewalUrl: () => `${membershipRenewalBaseUrl}/membership_renewal`,
};
